import { render, staticRenderFns } from "./SmallDisplayGroupList.vue?vue&type=template&id=5c9bda05&scoped=true"
import script from "./SmallDisplayGroupList.vue?vue&type=script&lang=js"
export * from "./SmallDisplayGroupList.vue?vue&type=script&lang=js"
import style0 from "./SmallDisplayGroupList.vue?vue&type=style&index=0&id=5c9bda05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9bda05",
  null
  
)

export default component.exports